import React from 'react';

export const ModalDateFieldContext = React.createContext(false);

export function ModalDateFieldProvider({ children }) {
  return (
    <ModalDateFieldContext.Provider value={true}>
      {children}
    </ModalDateFieldContext.Provider>
  );
}

export const useIsModalDateField = () =>
  React.useContext(ModalDateFieldContext);
